import { matchPath } from 'react-router-dom';

// Route configuration mapping pathname patterns to title configuration
export const routeTitleConfig = [
  // Login and auth routes
  {
    path: '/login',
    title: 'login',
    showActiveEvent: false,
  },
  {
    path: '/forgot-password',
    title: 'forgotPassword',
    showActiveEvent: false,
  },
  {
    path: '/reset-password',
    title: 'resetPassword',
    showActiveEvent: false,
  },

  // Event Groups
  {
    path: '/event-groups/:status',
    title: 'eventHome',
    showActiveEvent: false,
    dynamicTitle: true,
    getTitleFromParams: params => {
      if (params.status === 'past') {
        return 'pastEventGroups';
      }
      if (params.status === 'all') {
        return 'allEventGroups';
      }
      return 'activeEventGroups';
    },
  },
  {
    path: '/event-group/:id',
    exact: true,
    title: 'custom',
    component: 'EventGroupHome',
    showActiveEvent: false,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/detail',
    title: 'custom',
    component: 'EventGroupHome',
    showActiveEvent: false,
    isEventGroup: true,
  },

  // Event Group - Teams
  {
    path: '/event-group/:id/teams',
    exact: true,
    title: 'eventTeamList',
    showActiveEvent: true,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/teams/:teamId',
    title: 'custom',
    component: 'TeamDetail',
    showActiveEvent: true,
    isEventGroup: true,
  },

  // Event Group - Volunteers
  {
    path: '/event-group/:id/volunteers',
    exact: true,
    title: 'eventVolunteerList',
    showActiveEvent: true,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/volunteers/:volunteerId',
    title: 'custom',
    component: 'VolunteerDetail',
    showActiveEvent: true,
    isEventGroup: true,
  },

  // Event Group - Members
  {
    path: '/event-group/:id/members',
    exact: true,
    title: 'eventMemberList',
    showActiveEvent: true,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/members/:memberId',
    title: 'custom',
    component: 'MemberDetail',
    showActiveEvent: true,
    isEventGroup: true,
  },

  // Event Group - Supporters
  {
    path: '/event-group/:id/supporters',
    exact: true,
    title: 'eventSupporterList',
    showActiveEvent: true,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/supporters/:supporterId',
    title: 'custom',
    component: 'SupporterDetail',
    showActiveEvent: true,
    isEventGroup: true,
  },

  // Event Group - Specific Events
  {
    path: '/event-group/:id/events/:eventId/detail',
    title: 'eventHome',
    showActiveEvent: true,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/events/:eventId/teams',
    exact: true,
    title: 'eventTeamList',
    showActiveEvent: true,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/events/:eventId/teams/:teamId',
    title: 'custom',
    component: 'TeamDetail',
    showActiveEvent: true,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/events/:eventId/volunteers',
    exact: true,
    title: 'eventVolunteerList',
    showActiveEvent: true,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/events/:eventId/volunteers/:volunteerId',
    title: 'custom',
    component: 'VolunteerDetail',
    showActiveEvent: true,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/events/:eventId/members',
    exact: true,
    title: 'eventMemberList',
    showActiveEvent: true,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/events/:eventId/members/:memberId',
    title: 'custom',
    component: 'MemberDetail',
    showActiveEvent: true,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/events/:eventId/supporters',
    exact: true,
    title: 'eventSupporterList',
    showActiveEvent: true,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/events/:eventId/supporters/:supporterId',
    title: 'custom',
    component: 'SupporterDetail',
    showActiveEvent: true,
    isEventGroup: true,
  },

  // Event Group - Settings
  {
    path: '/event-group/:id/setting/team-tags',
    title: 'teamTags',
    showActiveEvent: false,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/setting/team-groups',
    title: 'teamGroups',
    showActiveEvent: false,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/setting/member-tags',
    title: 'memberTags',
    showActiveEvent: false,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/setting/volunteer-tags',
    title: 'volunteerTags',
    showActiveEvent: false,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/setting/volunteer-groups',
    title: 'volunteerGroups',
    showActiveEvent: false,
    isEventGroup: true,
  },
  {
    path: '/event-group/:id/setting/global-setting',
    title: 'globalSetting',
    showActiveEvent: false,
    isEventGroup: true,
  },

  // Events
  {
    path: '/events/:status',
    title: 'welcomeText',
    showActiveEvent: false,
  },
  {
    path: '/event/:id',
    exact: true,
    title: 'eventHome',
    showActiveEvent: true,
  },
  {
    path: '/event/:id/detail',
    title: 'eventHome',
    showActiveEvent: true,
  },

  // Event - Teams
  {
    path: '/event/:id/teams',
    exact: true,
    title: 'eventTeamList',
    showActiveEvent: true,
  },
  {
    path: '/event/:id/teams/:teamId',
    title: 'custom',
    component: 'TeamDetail',
    showActiveEvent: true,
  },

  // Event - Volunteers
  {
    path: '/event/:id/volunteers',
    exact: true,
    title: 'eventVolunteerList',
    showActiveEvent: true,
  },
  {
    path: '/event/:id/volunteers/:volunteerId',
    title: 'custom',
    component: 'VolunteerDetail',
    showActiveEvent: true,
  },

  // Event - Members
  {
    path: '/event/:id/members',
    exact: true,
    title: 'eventMemberList',
    showActiveEvent: true,
  },
  {
    path: '/event/:id/members/:memberId',
    title: 'custom',
    component: 'MemberDetail',
    showActiveEvent: true,
  },

  // Event - Supporters
  {
    path: '/event/:id/supporters',
    exact: true,
    title: 'eventSupporterList',
    showActiveEvent: true,
  },
  {
    path: '/event/:id/supporters/:supporterId',
    title: 'custom',
    component: 'SupporterDetail',
    showActiveEvent: true,
  },

  // Users
  {
    path: '/users/:id',
    title: 'userProfile',
    showActiveEvent: false,
  },

  // Notifications
  {
    path: '/notifications',
    title: 'notifications',
    showActiveEvent: false,
  },

  // Admin routes
  {
    path: '/admin',
    exact: true,
    title: 'adminDashboard',
    showActiveEvent: false,
  },
  {
    path: '/admin/users',
    title: 'adminUsers',
    showActiveEvent: false,
  },
  {
    path: '/admin/sync-jobs',
    title: 'syncJobs',
    showActiveEvent: false,
  },
  {
    path: '/admin/hs-lg',
    title: 'hubSpotLogs',
    showActiveEvent: false,
  },
  {
    path: '/admin/bulk-import',
    title: 'bulkImport',
    showActiveEvent: false,
  },

  // Annual Stats
  {
    path: '/annual-stats',
    title: 'annualStats',
    showActiveEvent: false,
  },
];

/**
 * Matches the current pathname against route configuration
 * @param {string} pathname - Current pathname
 * @returns {object} - Matched route configuration with fallback
 */
export const getRouteConfig = pathname => {
  // Find matching route configuration
  const matchedRoute = routeTitleConfig.find(route => {
    const match = matchPath(
      {
        path: route.path,
        exact: route.exact || false,
      },
      pathname,
    );

    if (match) {
      return {
        ...route,
        params: match.params,
      };
    }
    return null;
  });

  if (matchedRoute) {
    const match = matchPath(
      {
        path: matchedRoute.path,
        exact: matchedRoute.exact || false,
      },
      pathname,
    );
    return {
      ...matchedRoute,
      params: match.params,
    };
  }

  // Check for eventgroup prefix fallback
  if (pathname.includes('/event-group/')) {
    return {
      title: 'eventHome',
      showActiveEvent: false,
      isEventGroup: true,
      params: {},
    };
  }

  // Default fallback
  return {
    title: 'welcomeText',
    showActiveEvent: false,
    isEventGroup: false,
    params: {},
  };
};
